import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import Tooltip from '../Tooltip';

interface CardDescriptionProps {
  text?: string;
}

const useStyles = makeStyles()(() => ({
  root: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
    WebkitBoxOrient: 'vertical',
    maxWidth: '245px',
    textOverflow: 'ellipsis',
  },
}));

const CardDescription = (props: CardDescriptionProps) => {
  const { text } = props;
  const { classes } = useStyles();
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleMouseEnter: React.MouseEventHandler<HTMLSpanElement> = e => {
    const parent = e.target as HTMLElement;
    const childTextNode = parent.childNodes.item(0);
    if (document.createRange && childTextNode) {
      const range = document.createRange();
      range.selectNodeContents(childTextNode);
      if (range.getBoundingClientRect) {
        const rect = range.getBoundingClientRect();
        if (rect) {
          const textNodeHeight = rect.bottom - rect.top;
          /**
           * If the parent (h5 element in this case),
           * has a smaller height (expect this to reflect (line height) * (max number of lines) to show for text node),
           * then let's assume that because text doesn't fit in height, we are showing ellipsis
           * and therefore can show tooltip
           */
          setShowTooltip(textNodeHeight > parent.offsetHeight);
        }
      }
    }
  };

  const handleMouseExit = () => {
    setShowTooltip(false);
  };

  if (!text) return null;

  return (
    <Tooltip open={showTooltip} text={text || ''} placement="top">
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
        <Typography variant="pSm" className={classes.root}>
          {text}
        </Typography>
      </div>
    </Tooltip>
  );
};

export default CardDescription;
